/**
 * The authorized preview endpoint resolves template variables and returns a
 * complete HTML document (including its snapshot CSS). Keep it untouched for
 * iframe `srcDoc`; it is never inserted into the application DOM.
 */
export const authorizedPreviewSrcDoc = (bytes: ArrayBuffer) => new TextDecoder().decode(bytes);
